module.exports = __webpack_public_path__ + "img/preferred-silver.fb5b0e7d.svg";